{
    "oldParams": true,
    "wave_type": 3,
    "p_env_attack": 0.19,
    "p_env_sustain": 0.137,
    "p_env_punch": 0.242,
    "p_env_decay": 0.785,
    "p_base_freq": 0.107,
    "p_freq_limit": 0,
    "p_freq_ramp": -0.324,
    "p_freq_dramp": 0,
    "p_vib_strength": 0.5466653562384644,
    "p_vib_speed": 0.07026114933406258,
    "p_arp_mod": 0,
    "p_arp_speed": 0,
    "p_duty": 0,
    "p_duty_ramp": 0,
    "p_repeat_speed": 0.434,
    "p_pha_offset": 0,
    "p_pha_ramp": 0,
    "p_lpf_freq": 1,
    "p_lpf_ramp": 0,
    "p_lpf_resonance": 0,
    "p_hpf_freq": 0,
    "p_hpf_ramp": 0,
    "sound_vol": 0.25,
    "sample_rate": 44100,
    "sample_size": 8
  }